(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/orderBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/orderBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.orderBy, global.convert);
    global.orderBy = mod.exports;
  }
})(this, function (exports, _orderBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.orderBy = undefined;

  var _orderBy3 = _interopRequireDefault(_orderBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of sorted by <code>iteratees</code> in specified <code>orders</code>.
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[{@link https://lodash.com/docs#identity|lodash.identity}]] The iteratees to sort by.
   * @param {string[]} [orders] The sort orders of <code>iteratees</code>.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#orderBy|lodash.orderBy} for more information.
   * @example
   * orderBy({ nested: { prop: [{ name: 'Yvo', age: 2 }, { name: 'Nico', age: 666 }, { name: 'Nico', age: 30 }] } }, 'nested.prop', ['name', 'age'], ['asc', 'desc'])
   * // => { nested: { prop: [{ name: 'Nico', age: 666 }, { name: 'Nico', age: 30 }, { name: 'Yvo', age: 2 }] } }
   * @since 0.3.0
   */
  var orderBy = (0, _convert.convert)(_orderBy3.default);
  exports.orderBy = orderBy;
  exports.default = orderBy;
});